import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DpDatePickerModule } from 'ng2-date-picker';

import { DFManagementDebounceClickDirective } from 'app/df-management/shared/df-management-debounce-click.directive';

import { SharedModule } from '../shared/shared.module';

import { DfManagementComponent } from './df-management.component';
import { DF_MANAGEMENT_ROUTES } from './df-management.routes';

import { DfMasterDataListComponent } from './df-master-data-list/df-master-data-list.component';
import { DfOptionalChargesComponent } from './df-optional-charges/df-optional-charges.component';
import { DfTransactionListComponent } from './df-transaction-list/df-transaction-list.component';
import { DfManagementService } from './shared/df-management.service';
import { ValidateNumberDirective } from './shared/validate-number.directive';
import { DfAdminComponent } from './df-admin/df-admin.component';
import { DfCountryComponent } from './df-admin/df-country/df-country.component';
import { DfVariableChargesComponent } from './df-admin/df-variableCharges/df-variable-charges/df-variable-charges.component';
import { ViewCountryFormComponent } from './df-admin/df-country/view-country-form/view-country-form.component';
import { AddCountryFormComponent } from './df-admin/df-country/add-country-form/add-country-form.component';
import { DfMasterFileUploadComponent } from './file/df-master-file-upload/df-master-file-upload.component';
import { AlphabetOnlyDirective } from './shared/alphabet-only.directive';
import { DfCustomPaginationComponent } from './df-custom-pagination/df-custom-pagination.component';
import { FilterPipe } from './shared/filter.pipe';
import { UpperCaseInputDirective } from './shared/to-uppercase.directive';
import { CapitalizeFirstDirective } from './shared/capitalize-first-letter.directive';
import { DfTransactionFileUploadComponent } from './file/df-transaction-file-upload/df-transaction-file-upload.component';
import { NumericValueOnlyDirective } from './shared/numericValue-only.directive';
import { DfAdminFileUploadComponent } from './file/df-admin-file-upload/df-admin-file-upload/df-admin-file-upload.component';
import { CaptureLogsComponent } from './df-logs/capture-logs/capture-logs.component';
import { AddCalendarComponent } from './df-admin/df-country/add-calendar/add-calendar.component';
import {
  DfTransactionQuickFilterComponent
} from './df-transaction-list/components/df-transaction-quick-filter.component';

@NgModule({
  imports: [
    RouterModule.forChild(DF_MANAGEMENT_ROUTES),
    SharedModule,
    ReactiveFormsModule,
    DpDatePickerModule,
    FormsModule,
  ],
  declarations: [
    DfMasterDataListComponent,
    DfTransactionListComponent,
    DfTransactionQuickFilterComponent,
    DfManagementComponent,
    ValidateNumberDirective,
    DfOptionalChargesComponent,
    DFManagementDebounceClickDirective,
    DfAdminComponent,
    DfCountryComponent,
    DfVariableChargesComponent,
    ViewCountryFormComponent,
    AddCountryFormComponent,
    DfMasterFileUploadComponent,
    DfCustomPaginationComponent,
    FilterPipe,
    AlphabetOnlyDirective,
    UpperCaseInputDirective,
    CapitalizeFirstDirective,
    DfTransactionFileUploadComponent,
    NumericValueOnlyDirective,
    DfAdminFileUploadComponent,
    CaptureLogsComponent,
    AddCalendarComponent
],

  providers: [
    DfManagementService
  ]
})
export class DfManagementModule { }
